// backButtonManager.js
import { ref } from 'vue'
import { App } from '@capacitor/app'
const customBackHandler = ref(null)

export function setCustomBackHandler(handler) {
  customBackHandler.value = handler
}

export function clearCustomBackHandler() {
  customBackHandler.value = null
}

export function getCustomBackHandler() {
  return customBackHandler.value
}
export function useDefaultBackHandler(router) {

  console.log("router "+router.currentRoute);
    if (router.currentRoute.value.path === '/') {
      const confirmExit = window.confirm('Do you really want to exit the app?')
	if(confirmExit){
      App.exitApp()
	}
    } else {
      router.back()
    }
}
